export default {
  buttons: {
    cancel: "Anulare",
    dismiss: "Inchide",
    add_waypoint: "Adaugare destinatie"
  },
  distance: {
    value: "{distance, number, distance} {unit}",
    unit: {
      miles: "Mi"
    }
  },
  search: {
    title: "Cautare",
    placeholder: "Introdu o locatie",
    enter_location: "Introdu o locatie",
    help: {
      inactive: "Cautare"
    }
  },
  filters: {
    title: "Filtre",
    amenities: {
      title: "Servicii si Facilitati"
    },
    fuels: {
      title: "Tip carburant"
    }
  },
  directions: {
    title: "Planificator rute",
    placeholder: {
      destination: "Introdu o locatie",
      waypoint: "Introdu o locatie"
    },
    route: {
      title: "Optiuni Rute",
      avoid_tolls: "Evitare drumuri taxabile",
      avoid_highways: "Evitare autostrazi",
      title_corridor: "Distanta de la traseu la statie de carburant"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# Zi} other {# Zile}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# Minut} other {# Minute}}\
`,
    button: "Cautare"
  },
  locations: {
    title: "Locatii",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} de la {place}"
  },
  info_window: {
    title: "Detalii statie",
    location_id: "ID Statie",
    services: "Servicii si Facilitati",
    nearby: "In apropiere",
    opening_hours: {
      title: "Ore de functionare",
      mon: "Luni",
      tue: "Marti",
      wed: "Miercuri",
      thu: "Joi",
      fri: "Vineri",
      sat: "Sambata",
      sun: "Duminica",
      open_twentyfourhours: "Non-stop",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      last_updated_on: "Ultima actualizare",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "Planificator rute"
  },
  fuels: {
    adblue: "Adblue",
    fuelsave_midgrade_gasoline: "Shell FuelSave 95",
    fuelsave_regular_diesel: "Shell FuelSave Diesel",
    premium_diesel: "Shell V-Power Nitro+ Diesel",
    truck_diesel: "Shell FuelSave Truck Diesel"
  },
  amenities: {
    austrian_highway_sticker: "Vigneta Austria",
    bank_note_acceptor: "bancomat",
    cafe: "restaurant cu autoservire",
    carwash: "Spalatorie",
    clubsmart_card: "Card Shell ClubSmart",
    credit_card_american_express: "American Express",
    credit_card_diners_club: "Diners Club",
    credit_card_mastercard: "Mastercard",
    credit_card_visa: "Visa",
    credit_card: "card credit",
    czech_highway_sticker: "Vigneta Cehia",
    euroshell_card: "card euroShell/Shell",
    fleet_card_dkv: "Card DKV",
    fleet_card_eni: "Card Eni",
    fleet_card_esso: "Card Esso",
    fleet_card_general: "Card flota",
    fleet_card_uta: "Card UTA",
    food_offerings: "Oferta produse alimentare",
    full_service: "Servire asistata",
    guarded_car_park: "Parcare pazita",
    hgv_lane: "Statie pentru Camioane",
    high_speed_diesel_pump: "Pompa debit ridicat Motorina",
    hungarian_highway_sticker: "Vigneta Ungaria",
    ido_ticket: "Ido Tichet",
    parking_lanes: "Spatiu Parcare",
    partner_loyalty_accepted: "Acceptanta Partener Loialitate",
    pay_at_pump: "Plata la pompa",
    self_service: "Autoservire",
    shell_card: "card euroShell/Shell",
    shell_club_smart_extra_card: "Card Shell ClubSmart Extra",
    shop: "Magazin",
    shower: "Dusuri",
    slovak_highway_sticker: "Vigneta Slovacia",
    standard_toilet: "Toaleta",
    supermarket_fuel_discount: "Reduceri combustibil",
    tim_hortons: "Tim Horton",
    toilet: "Toaleta",
    truck_parking: "Parcare camioane",
    truckport: "Statie destinata special Camioanelor",
    twenty_four_hour: "24 Ore",
    vehicle_identity_system: "Sistem Idetificare vehicul"
  },
  settings: {
    title: "Setari",
    tooltip: "Setari",
    distance_units: {
      title: "Distanta",
      km: "Kilometri",
      miles: "Mile"
    },
    language: {
      title: "Limba"
    }
  }
}
